// extracted by mini-css-extract-plugin
module.exports = {"crypto-pro-signature-modal-content__overlapping":"_3VoYy8GsaRIDuNs7fwZWT_","crypto-pro-signature-modal-content__overlapping__warning":"UlbjFkP-tIO-wWocVFZcp"};